import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { MenuItem } from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  userImage: any;
  profileOption!: MenuItem[];
  loginDisplay = false;

  constructor(
    private authService: MsalService,
    private router: Router,
    private commonSvc: CommonService,
    private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.commonSvc.isLogin.subscribe((status: boolean) => {
      this.loginDisplay = status
      if (status) {
        this.getProfilePhoto()
      }
    })
    // if(this.loginDisplay){
    //   this.getProfilePhoto();
    // }
  }

  getProfilePhoto() {
    this.commonSvc.getImage().subscribe((blob) => {
      var urlCreator = window.URL || window.webkitURL;
      this.userImage = this.domSanitizer.bypassSecurityTrustUrl(
        urlCreator.createObjectURL(blob)
      )
    })
    this.profileOption = [
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: () => {
          this.logout();
        }
      }
    ];
  }

  logout() {
    this.authService.logoutRedirect();
  }

  GotoExisting() {
    this.router.navigate(['existing']);
  }
  GotoTranslate() {
    this.router.navigate(['Translate']);
  }

}
